import Facebook from "./facebook.container";

export default Facebook;
